import WorkService from '@/service/work';
import localforage from 'localforage';
import { isEmpty } from 'lodash';
import { observable, action, runInAction } from 'mobx';

const moCapital = observable({
  capitalTabActive: '人均营业收入',
  capitalTimeActive: '2018',
  isDataModel: false,
  dataYear: '2020',
  revenue: <any>'',
  profit: <any>'',
  salary: <any>'',
  revenueFlag: <any>false,
  profitFlag: <any>false,
  salaryFlag: <any>false,
  showCompanyName: false,
  capActiveShow: 'chart',
  capitalList: <any>{},
  dataList: <any>[],
});


// 修改tab
const changeTab = action(async (val: string) => {
  runInAction(() => {
    moCapital.capitalTabActive = val;
  });
  const humanData: any = await localforage.getItem('humans') || {};
  humanData.captab = val;
  localforage.setItem('humans', humanData);
});

// 修改默认tab
const changeCapTab = action(async (val: string) => {
  runInAction(() => {
    moCapital.capitalTabActive = val;
  });
});

// 修改时间tab
const changeTimeTab = action(async (val: string) => {
  runInAction(() => {
    moCapital.capitalTimeActive = val;
  });
  const list = await WorkService.capitalAnalysis({
    year: val,
  });
  runInAction(() => {
    moCapital.capitalList = list;
  });
  const humanData: any = await localforage.getItem('humans') || {};
  humanData.captime = val;
  localforage.setItem('humans', humanData);
});

// 关闭弹框

const changeModel = (val: boolean) => {
  runInAction(() => {
    moCapital.isDataModel = val;
  });
};

// 修改数据时间

const changeDataTime = (val: string) => {
  runInAction(() => {
    const list = moCapital.dataList?.filter((res: any) => res.year === val) || [];
    moCapital.dataYear = val;
    if (!isEmpty(list)) {
      moCapital.revenue = list[0].revenue_per_staff;
      moCapital.profit = list[0].profit_per_staff;
      moCapital.salary = list[0].cost_per_staff;
    } else {
      moCapital.revenue = '';
      moCapital.profit = '';
      moCapital.salary = '';
    }
  });
};

// 人均营业收入

const changeProfit = (val: string) => {
  runInAction(() => {
    moCapital.profit = val.replace(/^\D*([0-9]\d*\.?\d*)?.*$/, '$1');
  });
};

const profitFocus = () => {
  runInAction(() => {
    moCapital.profit = moCapital.profit.replace(/,/g, '');
  });
};

const profitBlurs = () => {
  runInAction(() => {
    moCapital.profit = Number(moCapital.profit).toLocaleString();
  });
};

// 人均净利润

const changeRevemue = (val: string) => {
  runInAction(() => {
    moCapital.revenue = val.replace(/^\D*([0-9]\d*\.?\d*)?.*$/, '$1');
  });
};

const revemueFocus = () => {
  runInAction(() => {
    moCapital.revenue = moCapital.revenue.replace(/,/g, '');
  });
};

const revemueBlurs = () => {
  runInAction(() => {
    moCapital.revenue = Number(moCapital.revenue).toLocaleString();
  });
};

// 人均薪酬成本

const changeSalary = (val: string) => {
  runInAction(() => {
    moCapital.salary = val.replace(/^\D*([0-9]\d*\.?\d*)?.*$/, '$1');
  });
};

const salaryFocus = () => {
  runInAction(() => {
    moCapital.salary = moCapital.salary.replace(/,/g, '');
  });
};

const salaryBlurs = () => {
  runInAction(() => {
    moCapital.salary = Number(moCapital.salary).toLocaleString();
  });
};

// 展示表格还是图表
const changeShowCapital = action(async (val: string) => {
  runInAction(() => {
    moCapital.capActiveShow = val;
  });
  const humanData: any = await localforage.getItem('humans') || {};
  humanData.captable = val;
  localforage.setItem('humans', humanData);
});

// 展示默认表格还是图表
const changeCapShow = action(async (val: string) => {
  runInAction(() => {
    moCapital.capActiveShow = val;
  });
});


// 修改默认时间

const changeDefaltCapital = action(async (val: string) => {
  runInAction(() => {
    moCapital.capitalTimeActive = val;
  });
});

// 获取默认数据
const getCapitalAnalysis = action(async (val: any) => {
  runInAction(() => {
    moCapital.capitalList = val;
  });
});

// 弹框默认数据

const changeDefalutDatas = action(async (data: any) => {
  if (isEmpty(data)) return;
  const list = data.filter((res: any) => res.year === moCapital.dataYear);
  runInAction(() => {
    moCapital.dataList = data;
    if (!isEmpty(list)) {
      moCapital.revenue = Number(list[0].revenue_per_staff).toLocaleString();
      moCapital.profit = Number(list[0].profit_per_staff).toLocaleString();
      moCapital.salary = Number(list[0].cost_per_staff).toLocaleString();
    }
  });
});

// 提交我的数据

const canSure = action(() => {
  runInAction(() => {
    if (!moCapital.revenue) {
      moCapital.revenueFlag = true;
    } else {
      moCapital.revenueFlag = false;
    }
    if (!moCapital.profit) {
      moCapital.profitFlag = true;
    } else {
      moCapital.profitFlag = false;
    }
    if (!moCapital.salary) {
      moCapital.salaryFlag = true;
    } else {
      moCapital.salaryFlag = false;
    }
  });
  if (moCapital.salary && moCapital.profit && moCapital.revenue) {
    WorkService.editUserData({
      year: moCapital.dataYear,
      revenue_per_staff: moCapital.revenue.toString().replace(/,/g, ''),
      profit_per_staff: moCapital.profit.toString().replace(/,/g, ''),
      cost_per_staff: moCapital.salary.toString().replace(/,/g, ''),
    });
    if (moCapital.dataYear === moCapital.capitalTimeActive) {
      WorkService.capitalAnalysis({
        year: moCapital.capitalTimeActive,
      }).then((list: any) => {
        runInAction(() => {
          moCapital.capitalList = list;
        });
      });
    }
    changeModel(false);
  }
});

export default moCapital;
export {
  changeTab, changeTimeTab, changeModel, changeDataTime, changeRevemue, salaryFocus, changeShowCapital,
  revemueFocus, revemueBlurs, changeProfit, profitFocus, profitBlurs, changeSalary, salaryBlurs, changeDefaltCapital,
  getCapitalAnalysis, changeDefalutDatas, canSure, changeCapTab, changeCapShow,
};
